var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSortButtonIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 16,
    viewBox: "0 0 8 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "topArrow",
    d: "M4.11455 2.25468L6.40504 4.54505C6.76817 4.90816 7.35476 4.90816 7.71789 4.54505C8.08102 4.18194 8.08102 3.59539 7.71789 3.23228L4.76631 0.271559C4.40319 -0.0915478 3.81659 -0.0915479 3.45347 0.271559L0.501891 3.22297C0.138764 3.58608 0.138763 4.17263 0.501891 4.53574C0.865019 4.89885 1.45161 4.89885 1.81474 4.53574L4.11455 2.25468Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "bottomArrow",
    d: "M4.11495 13.7443L1.82445 11.454C1.46132 11.0909 0.874731 11.0909 0.511603 11.454C0.148476 11.8171 0.148476 12.4036 0.511603 12.7667L3.46318 15.7275C3.82631 16.0906 4.4129 16.0906 4.77602 15.7275L7.7276 12.7761C8.09073 12.4129 8.09073 11.8264 7.7276 11.4633C7.36447 11.1002 6.77788 11.1002 6.41476 11.4633L4.11495 13.7443Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortButtonIcon);
export default __webpack_public_path__ + "static/media/sortButtonIcon.41d2211b621d840621670cfedfd82dd3.svg";
export { ForwardRef as ReactComponent };